import React, { useMemo, useState, useEffect } from 'react';
import { Select, SelectOption } from '@launchmetrics/lm-ui';
import { useK2Loader } from 'hooks/useK2Loader';
import Loader from 'components/Loader';

function CelebritySelect(props) {
    const { selected, onChange } = props;

    const [inputId, setInputId] = useState(selected?.id ? String(selected.id) : '');

    const [selectedOption, setSelectedOption] = useState(
        selected?.id ? { key: selected.id, value: `${selected.id} - ${selected.name ?? ''}` } : null
    );

    const [loading, raw] = useK2Loader(
        inputId ? `/celebrity/search?celebrity_id=${encodeURIComponent(inputId)}` : null
    );

    const list = useMemo(() => {
        if (Array.isArray(raw)) return raw;
        if (raw && Array.isArray(raw.data)) return raw.data;
        return [];
    }, [raw]);

    const selectOptions = useMemo(
        () => list.map(item => ({
            key: item.id,
            value: `${item.id} - ${item.name}${item.linked_voice_id ? ' (linked)' : ''}`,
            data: item,
            isDisabled: !!item.linked_voice_id
        })),
        [list]
    );

    const handleChange = (opt) => {
        onChange('celebrity', opt.data);
    };

    const onClear = () => {
        onChange('celebrity', null)
        setSelectedOption(null);
        setInputId('');
    };

    useEffect(() => {
        if (selected?.id) {
            setSelectedOption({ key: selected.id, value: `${selected.id} - ${selected.name ?? ''}` });
            setInputId(String(selected.id));
        }
    }, [selected?.id, selected?.name]);

    if (loading) return <Loader size={20} />;

    return (
        <Select
            searchable
			clearable
            onChange={handleChange}
            onClear={onClear}
            placeholder="Enter celebrity ID..."
            optionValue={selectedOption}
            inputProps={{
                onInput: (e) => {
                    setInputId(e.currentTarget.value);
                }
            }}
        >
            {selectOptions.map((type) => (
                <SelectOption 
                    key={type.value} 
                    optionValue={{ key: type.key, value: type.value, data: type.data }} 
                    styleProps={
                        type.isDisabled
                            ? { color: '#ccc', cursor: 'not-allowed', pointerEvents: 'none' }
                            : {}
                    }
                    onClick={(val) => {
                        if (type.isDisabled) return;
                    }}
                />
            ))}
        </Select>
    );
}

export default CelebritySelect;
